import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import FooterTrustChat from '../../components/common/FooterTrustChat';
import VerificationInput from '../../components/common/verificationInput';
import './style.css';
import VerificationButton from '../../components/common/verificationButton';

function LoginVerification() {
  const [val1, setval1] = useState('');
  const [val2, setval2] = useState('');
  const [val3, setval3] = useState('');
  const [val4, setval4] = useState('');
  const [genericError, setGenericError] = useState('');

  const enableHandler = () => val1.trim() && val2.trim() && val3.trim() && val4.trim();
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  return (
    <div>
      <div className="adminPanelMainDiv__login">
        <div className="inputDivStyle-login">
          <div className="textDiv">
            <p className="text__create">{t.EMAIL_VERIFICATION}</p>
            <p className="text__start">{t.EMAIL_CONF}</p>
          </div>
          <div className="verification__input">
            <p className="sent__verification">{t.EMAIL_SENT}</p>
            <VerificationInput
              val1={val1}
              val2={val2}
              val3={val3}
              val4={val4}
              setval1={setval1}
              setval2={setval2}
              setval3={setval3}
              setval4={setval4}
              setGenericError={setGenericError}
              genericError={genericError}
            />
          </div>

          <div className="btn-class">
            <VerificationButton
              enable={enableHandler()}
              title={t.BTN_CONTINUE}
              onClick={() => enableHandler()}
            />
          </div>
        </div>
      </div>
      <FooterTrustChat />
    </div>
  );
}

export default LoginVerification;
